// Mock data for Parler Cloud website

// Parler Cloud Packages
export const cloudPackages = [
  {
    id: 'ignite',
    name: 'Ignite',
    monthlyPrice: 29,
    annualPrice: 23.20,
    tagline: 'Ideal for personal projects and small websites',
    specs: {
      vCPU: 2,
      memory: '4 GB',
      nvmeStorage: '100 GB',
      objectStorage: '1 TB',
      cdnBandwidth: '2 TB'
    },
    features: [
      'Integrated firewall',
      'Basic web-application firewall',
      'DDoS protection',
      'API keys',
      '24/7 email support'
    ],
    popular: false
  },
  {
    id: 'ascend',
    name: 'Ascend',
    monthlyPrice: 99,
    annualPrice: 79.20,
    tagline: 'Perfect for developers and growing startups',
    specs: {
      vCPU: 4,
      memory: '8 GB',
      nvmeStorage: '250 GB',
      objectStorage: '3 TB',
      cdnBandwidth: '5 TB'
    },
    features: [
      'Kubernetes container orchestration',
      'Advanced WAF and API security',
      'Bot management',
      'Rate-limiting',
      'Phone support'
    ],
    popular: true
  },
  {
    id: 'orbit',
    name: 'Orbit',
    monthlyPrice: 249,
    annualPrice: 199.20,
    tagline: 'Great for SaaS platforms and media companies',
    specs: {
      vCPU: 8,
      memory: '16 GB',
      nvmeStorage: '500 GB',
      objectStorage: '10 TB',
      cdnBandwidth: '15 TB'
    },
    features: [
      'Multi-zone high availability',
      'Edge functions',
      'Traffic splitting',
      'Predictive prefetch',
      'Managed threat intelligence'
    ],
    popular: false
  },
  {
    id: 'galaxy',
    name: 'Galaxy',
    monthlyPrice: 599,
    annualPrice: 479.20,
    tagline: 'Designed for large enterprises and mission-critical apps',
    specs: {
      vCPU: 16,
      memory: '32 GB',
      nvmeStorage: '1 TB',
      objectStorage: '30 TB',
      cdnBandwidth: '50 TB'
    },
    features: [
      'Unlimited compute instances',
      'Custom load balancing',
      'Dedicated account manager',
      'Enterprise support with 99.99% SLA',
      'Dedicated Open Compute hardware'
    ],
    popular: false
  }
];

// Parler CDN Packages
export const cdnPackages = [
  {
    id: 'edgestarter',
    name: 'EdgeStarter',
    monthlyPrice: 19,
    annualPrice: 15.20,
    tagline: 'For personal projects',
    features: [
      'Global CDN',
      'Basic DDoS Protection',
      '100GB Bandwidth'
    ],
    popular: false
  },
  {
    id: 'edgepro',
    name: 'EdgePro',
    monthlyPrice: 29,
    annualPrice: 23.20,
    tagline: 'For growing businesses',
    features: [
      'WAF Standard',
      'Image Optimization',
      '1TB Bandwidth'
    ],
    popular: true
  },
  {
    id: 'edgebusiness',
    name: 'EdgeBusiness',
    monthlyPrice: 149,
    annualPrice: 119.20,
    tagline: 'For scale',
    features: [
      'WAF Advanced',
      'Bot Management',
      '5TB Bandwidth'
    ],
    popular: false
  },
  {
    id: 'edgeenterprise',
    name: 'EdgeEnterprise',
    monthlyPrice: null,
    annualPrice: null,
    tagline: 'For global platforms',
    features: [
      'Dedicated Support',
      'Custom SLAs',
      'Unlimited Bandwidth'
    ],
    popular: false,
    custom: true
  }
];

// Parler Deploy Packages
export const deployPackages = [
  {
    id: 'launchpad',
    name: 'LaunchPad',
    monthlyPrice: 10,
    annualPrice: 8,
    tagline: 'For hobbyists',
    priceUnit: '/seat/mo',
    features: [
      'Git Integration',
      'Unlimited Previews',
      '1 Concurrent Build'
    ],
    popular: false
  },
  {
    id: 'velocity',
    name: 'Velocity',
    monthlyPrice: 25,
    annualPrice: 20,
    tagline: 'For teams',
    priceUnit: '/seat/mo',
    features: [
      'Team Roles',
      '3 Concurrent Builds',
      'Password Protection'
    ],
    popular: true
  },
  {
    id: 'accelerate',
    name: 'Accelerate',
    monthlyPrice: 99,
    annualPrice: 79.20,
    tagline: 'For organizations',
    priceUnit: '/seat/mo',
    features: [
      'SSO/SAML',
      'Audit Logs',
      '10 Concurrent Builds'
    ],
    popular: false
  },
  {
    id: 'hyperscale',
    name: 'HyperScale',
    monthlyPrice: null,
    annualPrice: null,
    tagline: 'For enterprise',
    priceUnit: '',
    features: [
      'Private Runners',
      'Custom Contracts',
      'Dedicated Success Manager'
    ],
    popular: false,
    custom: true
  }
];

// Keep the old packages export for backward compatibility
export const packages = cloudPackages;

export const comparisonData = {
  categories: [
    {
      name: 'Compute & Architecture',
      parlerCloud: 'SmartOS on bare metal',
      aws: 'Proprietary hypervisor (Nitro)',
      azure: 'Proprietary hypervisor (Hyper-V)',
      googleCloud: 'Proprietary hypervisor',
      digitalOcean: 'Virtualized droplets'
    },
    {
      name: 'Pricing',
      parlerCloud: 'Flat packages, no hidden fees*',
      aws: 'Complex metered billing',
      azure: 'Complex metered billing',
      googleCloud: 'Complex metered billing',
      digitalOcean: 'Simple hourly/monthly'
    },
    {
      name: 'Ease of Use',
      parlerCloud: 'Unified dashboard',
      aws: 'Steep learning curve',
      azure: 'Moderate complexity',
      googleCloud: 'Moderate complexity',
      digitalOcean: 'Developer friendly'
    },
    {
      name: 'CDN & Security Integration',
      parlerCloud: 'Edgecast CDN, WAF, DDoS, API security included',
      aws: 'CloudFront + separate WAF',
      azure: 'Azure CDN + separate WAF',
      googleCloud: 'Cloud CDN + separate Armor',
      digitalOcean: 'Basic CDN, limited WAF'
    },
    {
      name: 'Storage',
      parlerCloud: 'NVMe + Manta / S3 compatible storage',
      aws: 'EBS + S3 (separate charges)',
      azure: 'Managed disks + Blob (separate)',
      googleCloud: 'Persistent disks + GCS (separate)',
      digitalOcean: 'Block + Spaces (separate)'
    },
    {
      name: 'Support & SLAs',
      parlerCloud: 'Included, up to 99.99% SLA',
      aws: 'Paid tiers required',
      azure: 'Paid tiers required',
      googleCloud: 'Paid tiers required',
      digitalOcean: 'Community + paid'
    },
    {
      name: 'Data Sovereignty',
      parlerCloud: 'Open Compute, open-source',
      aws: 'Proprietary infrastructure',
      azure: 'Proprietary infrastructure',
      googleCloud: 'Proprietary infrastructure',
      digitalOcean: 'Standard virtualization'
    }
  ]
};

export const navLinks = [
  { name: 'Home', path: '/' },
  { name: 'Packages', path: '/packages' },
  { name: 'Comparison', path: '/comparison' },
  { name: 'Contact', path: '/contact' }
];

export const heroContent = {
  tagline: 'Open, Powerful, Unified Cloud Built for Freedom',
  description: 'Parler Cloud combines compute, storage, networking, and security into one integrated service. Running on Open Compute hardware and built on Triton SmartOS and Edgecast CDN for maximum transparency and performance.',
  primaryCTA: 'View Packages',
  secondaryCTA: 'Contact Sales'
};

export const features = [
  {
    title: 'Triton SmartOS',
    description: 'Open-source virtualization delivering bare-metal performance with zones and containers.'
  },
  {
    title: 'Edgecast CDN',
    description: 'Enterprise-grade content delivery with built-in WAF, DDoS protection, and API security.'
  },
  {
    title: 'Open Compute Hardware',
    description: 'Transparent, efficient infrastructure designed for maximum performance and operational efficiency.'
  },
  {
    title: 'Unified Platform',
    description: 'Single dashboard for compute, storage, networking, and security management.'
  }
];
